'use client';

import { useState } from 'react';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';
import { Branch } from '@medprev-web-app/api-graphql-client';

import { BranchesListItem } from './branches-list-item.component';

import { AnalyticsBranchPageEnum } from '@/app/(main)/(pages)/_enums/analytics-branch-page.enum';
import { ContentContainer } from '@/components/ui/content-container.component';
import { Button } from '@/components/ui/button/button.component';
import { getAnalyticsPlugin } from '@/app/(main)/_components/logger/analytics/get-analytics-plugin';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';

interface BranchesListProps {
  citySlug: string;
  branches: Branch[];
  pageFrom: AnalyticsBranchPageEnum;
}

export const BranchesList = ({
  citySlug,
  branches,
  pageFrom,
}: BranchesListProps) => {
  const ITEMS_PER_PAGE = 5;
  const [page, setPage] = useState(1);
  const analytics = getAnalyticsPlugin();

  const branchesToDisplay = branches.slice(0, page * ITEMS_PER_PAGE);
  const hasMoreBranches = branchesToDisplay.length < branches.length;

  const showMoreResults = (): void => {
    analytics.track(AnalyticsEnum.CLICK_SHOW_MORE_BRANCHES, {
      pageFrom,
    });
    setPage((previous) => previous + 1);
  };

  return (
    <div
      className={hasMoreBranches ? 'pb-5 md:pb-6 lg:pb-10' : 'md:pb-6 xl:pb-10'}
    >
      <ul className="w-full flex flex-col items-center gap-0 md:gap-6">
        {branchesToDisplay.map((branch) => (
          <BranchesListItem
            key={branch.id}
            citySlug={citySlug}
            branch={branch}
            pageFrom={pageFrom}
          />
        ))}
      </ul>

      {hasMoreBranches && (
        <ContentContainer>
          <Button
            data-testid={DataTestIdEnum.CITY_BRANCH_LIST_SHOW_MORE_BRANCHES}
            className="mt-5 md:mt-6"
            variant="secondary"
            onClick={showMoreResults}
          >
            Mostrar mais unidades
          </Button>
        </ContentContainer>
      )}
    </div>
  );
};
